<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h4>Dimensions</h4>
        <h3>Enter Total width & drop measurements</h3>
      </v-flex>
      <v-flex xs12 v-if="$v.room.$error">
        <div v-if="!$v.room.name.required" class="red--text">Please enter Name</div>
        <div v-if="!$v.room.width.required" class="red--text">Please enter Width</div>
        <div v-if="!$v.room.width.between && type != 'Misc'" class="red--text">Please enter width between {{$v.room.width.$params.between.min}}mm and {{$v.room.width.$params.between.max}}mm</div>
        <div v-if="!$v.room.drop.required" class="red--text">Please enter Drop</div>
        <div v-if="!$v.room.drop.between && type != 'Misc'" class="red--text">Please enter drop between {{$v.room.drop.$params.between.min}}mm and {{$v.room.drop.$params.between.max}}mm</div>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field label="Name" v-model="room.name" :v="$v.room.name"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field label="Width" v-model="room.width" @change="clearIndividualDimensions" :v="$v.room.width"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field label="Drop" v-model="room.drop" :v="$v.room.drop"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <h4 class='mb-4'>Layout</h4>
    <div v-if='room.width'>
        <div class="layout row wrap" v-if="room.width <= 6000">
            <v-flex xs12 sm4 tile @click="selectOption('LR')" :class="selectedOption === 'LR' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/LR-asset.jpg"></v-img>
            </v-flex>
            <v-flex xs12 sm4 tile @click="selectOption('LL')" :class="selectedOption === 'LL' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/LL-asset.jpg"></v-img>
            </v-flex>
            <v-flex xs12 sm4 tile @click="selectOption('RR')" :class="selectedOption === 'RR' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/RR-asset.jpg"></v-img>
            </v-flex>
        </div>
        <div class="layout row wrap m0a width90">
            <v-flex xs12 sm6 tile @click="selectOption('LLL')" :class="selectedOption === 'LLL' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/LLL-asset.jpg"></v-img>
            </v-flex>
            <v-flex xs12 sm6 tile @click="selectOption('RRR')" :class="selectedOption === 'RRR' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/RRR-asset.jpg"></v-img>
            </v-flex>
        </div>
        <div class="layout row wrap">
            <v-flex xs12 sm6 tile @click="selectOption('LRR')" :class="selectedOption === 'LRR' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/LRR-asset.jpg"></v-img>
            </v-flex>
            <v-flex xs12 sm6 tile @click="selectOption('LLR')" :class="selectedOption === 'LLR' ? 'elevation-2':''">
                <v-img src="/static/LinkedAssets/LLR-asset.jpg"></v-img>
            </v-flex>
        </div>
    </div>
    <div v-if='selectedOption' class="mt-3">
        <h4>Individual dimensions</h4>
        <v-flex v-if="selectedOption === 'LL'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L1" v-model="easyLink.l1" @input="autoFillLastDimension"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L2" readonly v-model="easyLink.l2"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="selectedOption === 'LR'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L1" @input="autoFillLastDimension" v-model="easyLink.l1"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R2" readonly v-model="easyLink.r2"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="selectedOption === 'RR'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R1" @input="autoFillLastDimension" v-model="easyLink.r1"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R2" readonly v-model="easyLink.r2"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="selectedOption === 'LLL'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L1" @input="autoFillLastDimension" v-model="easyLink.l1"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L2" @input="autoFillLastDimension" v-model="easyLink.l2"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L3" readonly v-model="easyLink.l3"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="selectedOption === 'RRR'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R1" @input="autoFillLastDimension" v-model="easyLink.r1"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R2" @input="autoFillLastDimension" v-model="easyLink.r2"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R3" readonly v-model="easyLink.r3"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="selectedOption === 'LLR'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L1" @input="autoFillLastDimension" v-model="easyLink.l1"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L2" @input="autoFillLastDimension" v-model="easyLink.l2"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R3" readonly v-model="easyLink.r3"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="selectedOption === 'LRR'" row layout wrap>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>L</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="L1" @input="autoFillLastDimension" v-model="easyLink.l1"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R2" @input="autoFillLastDimension" v-model="easyLink.r2"></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm3>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <h3>R</h3>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="background:#abc; border-right: 0.5px solid #fff;">
                    <span class="vh">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center  style="border-right: 0.5px solid #fff; border-top: 2px solid #222;">
                    <span class="blur">aaaaaaaaaa aaaaaaaaa aaaaaaaaa</span>
                </v-flex>
                <v-flex xs12 sm12 pa-0 text-lg-center>
                    <v-text-field type='number' label="R3" readonly v-model="easyLink.r3"></v-text-field>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex v-if="showErr" xs12 sm12 style="color: red; margin-top: -48px;">
          All Individual dimensions should be between 0 to 3000.
        </v-flex>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
import { required, between } from 'vuelidate/lib/validators'

export default {
  props: {
    error: false,
    type: '',
    valueName: '',
    valueWidth: '',
    valueDrop: '',
    valueEasyLink: '',
    valueEasyLinkIndividuals: {}
  },
  data () {
    return {
      room: {
        name: null,
        width: null,
        drop: null
      },
      easyLink: {
        l1: 0,
        l2: 0,
        l3: 0,
        r1: 0,
        r2: 0,
        r3: 0
      },
      minWidth: 0,
      maxWidth: 0,
      minDrop: 0,
      maxDrop: 0,
      selectedOption: '',
      showErr: false
    }
  },
  validations () {
    if (this.type === 'Misc') {
      return {
        room: {
          name: { required },
          width: { required },
          drop: { required }
        }
      }
    } else {
      return {
        room: {
          name: { required },
          width: { required, between: between(this.minWidth, this.maxWidth) },
          drop: { required, between: between(this.minDrop, this.maxDrop) }
        }
      }
    }
  },
  watch: {
    valueName: function (val) {
      this.room.name = val
    },
    valueWidth: function (val) {
      this.room.width = val
    },
    valueDrop: function (val) {
      this.room.drop = val
    },
    valueEasyLink: function (val) {
      this.selectedOption = val
    },
    valueEasyLinkIndividuals: function (val) {
      this.easyLink = val
    },
    room: {
      handler (val) {
        this.$emit('room', val)
      },
      deep: true
    },
    ready (val) {
      this.$emit('ready', val)
    }
  },
  methods: {
    selectOption (option) {
      this.clearIndividualDimensions()
      this.selectedOption = option
      this.$emit('selected-option', option)
    },
    touch () {
      this.$v.room.$touch()
    },
    clearIndividualDimensions () {
      this.easyLink = {
        l1: 0,
        l2: 0,
        l3: 0,
        r1: 0,
        r2: 0,
        r3: 0
      }
    },
    autoFillLastDimension () {
      this.showErr = false
      if (this.selectedOption === 'LL') {
        this.easyLink.l2 = this.room.width - this.easyLink.l1
        if (this.easyLink.l2 <= 0) {
          this.showErr = true
        }
      } else if (this.selectedOption === 'LR') {
        this.easyLink.r2 = this.room.width - this.easyLink.l1
        if (this.easyLink.r2 <= 0) {
          this.showErr = true
        }
      } else if (this.selectedOption === 'RR') {
        this.easyLink.r2 = this.room.width - this.easyLink.r1
        if (this.easyLink.r2 <= 0) {
          this.showErr = true
        }
      } else if (this.selectedOption === 'LLL') {
        this.easyLink.l3 = this.room.width - (parseInt(this.easyLink.l1) + parseInt(this.easyLink.l2))
        if (this.easyLink.l3 <= 0) {
          this.showErr = true
        }
      } else if (this.selectedOption === 'RRR') {
        this.easyLink.r3 = this.room.width - (parseInt(this.easyLink.r1) + parseInt(this.easyLink.r2))
        if (this.easyLink.r3 <= 0) {
          this.showErr = true
        }
      } else if (this.selectedOption === 'LRR') {
        this.easyLink.r3 = this.room.width - (parseInt(this.easyLink.l1) + parseInt(this.easyLink.r2))
        if (this.easyLink.r3 <= 0) {
          this.showErr = true
        }
      } else if (this.selectedOption === 'LLR') {
        this.easyLink.r3 = this.room.width - (parseInt(this.easyLink.l1) + parseInt(this.easyLink.l2))
        if (this.easyLink.r3 <= 0) {
          this.showErr = true
        }
      }
      for (var prop in this.easyLink) {
        if (parseInt(this.easyLink[prop]) > 3000) {
          this.showErr = true
          break
        }
      }
      let individualsValues = {
        l1: this.easyLink.l1,
        l2: this.easyLink.l2,
        l3: this.easyLink.l3,
        r1: this.easyLink.r1,
        r2: this.easyLink.r2,
        r3: this.easyLink.r3
      }
      this.$emit('individuals-width', individualsValues)
    }
  },
  computed: {
    ready () {
      return !this.$v.room.$invalid
    }
  },

  created () {
    if (this.type === 'Panel Glide Blind') {
      this.minWidth = 300
      this.maxWidth = 4550
      this.minDrop = 600
      this.maxDrop = 2700
    } else if (this.type === 'Curtain') {
      this.minWidth = 400
      this.maxWidth = 6000
      this.minDrop = 400
      this.maxDrop = 4200
    } else if (this.type === 'Linked Roller Blind' || this.type === 'Linked Double Roller Blind') {
      this.minWidth = 300
      this.maxWidth = 9000
      this.minDrop = 400
      this.maxDrop = 3300
    } else if (this.type === 'Shutter') {
      this.minWidth = 300
      this.maxWidth = 3600
      this.minDrop = 400
      this.maxDrop = 3000
    } else {
      this.minWidth = 300
      this.maxWidth = 3000
      this.minDrop = 400
      this.maxDrop = 3000
    }
  }
}
</script>
<style scoped>
.vh {
    visibility: hidden
}
.blur {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  width: 100px;
  height: 100px;
  background-color: #ccc !important;
}
.width90 { width: 90%; }
.m0a { margin: 0 auto !important; }
.tile {
    overflow: hidden;
    cursor: pointer;
}
.tile.elevation-2 {
    border: solid 1px #ccc;
    border-color: #e83b68 !important;
}

.tile:not(.v-card--flat) {
  border-color: #e83b68 !important;
}

.tile:hover {
    background: lightgrey;
}

.middleline:after {
    content:"";
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 50%;
    border-left: 2px dotted #ff0000;
    transform: translate(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/parts/LinkedDimensionSelector.vue